import * as z from 'zod';

export const emailTemplateQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type EmailTemplateQueryLinkerSchema = z.infer<typeof emailTemplateQueryLinkerSchema>;
